import React from 'react';

// Страница без шапки и меню — когда её содержимое показывают ВНУТРИ другой
// страницы. У директора три экрана слились в один, и каждый из них по
// отдельности всё ещё рисовал свой Layout: вложенные меню и две шапки подряд.
//
// Все props (title, sections…) намеренно проглатываются: их выставляет тот,
// кто эту страницу вложил.
export default function Bare({ children }) {
  return <>{children}</>;
}
